import { TextField } from '@mui/material';

const normalizePhone = (value = '') => {
  if (!value) return '';

  let digits = value.replace(/\D/g, '');

  if (digits.startsWith('55')) {
    digits = digits.slice(2);
  }

  return digits.slice(0, 11);
};

const formatPhoneBR = (digits = '') => {
  if (!digits) return '';

  const ddd = digits.slice(0, 2);
  const part1 = digits.slice(2, 3);
  const part2 = digits.slice(3, 7);
  const part3 = digits.slice(7, 11);

  let result = '+55';

  if (ddd) result += ` (${ddd}`;
  if (ddd.length === 2) result += ')';

  if (part1) result += ` ${part1}`;
  if (part2) result += ` ${part2}`;
  if (part3) result += `-${part3}`;

  return result;
};

const PhoneInput = ({ label, name, value, onChange, onBlur, error, helperText, ...props }) => {
  const normalized = normalizePhone(value);
  const formatted = normalized ? formatPhoneBR(normalized) : '';

  const handleChange = (e) => {
    let digits = e.target.value.replace(/\D/g, '');

    if (digits.startsWith('55')) {
      digits = digits.slice(2);
    }

    digits = digits.slice(0, 11);

    onChange({
      target: {
        name,
        value: digits,
      },
    });
  };

  return (
    <div className="mb-5">
      {label && (
        <label htmlFor={name} className="block text-gray-700 text-sm font-medium mb-1.5">
          {label}
        </label>
      )}

      <TextField
        fullWidth
        name={name}
        id={name}
        value={formatted}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder="+55 (00) 0 0000-0000"
        size="small"
        error={error}
        helperText={helperText}
        inputProps={{ maxLength: 22 }}
        {...props}
      />
    </div>
  );
};

export default PhoneInput;
